import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Switch from 'react-switch'
import './ListOptions.css'
import { showOrHideWTFunds, showCapGainsOrPerformance } from '../../actions/actions'

// Provides options rows for the FundList
class ListOptions extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { checked: true }
    this.handleChange = this.handleChange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(checked) {
    this.setState({ checked })
    this.props.showOrHideWTFunds(checked)
  }

  // Change the table type based on the selection
  handleTypeChange = value => {
    // console.log('Type: ' + value);
    this.props.showCapGainsOrPerformance(value)
  }

  // Change the table type based on the selection
  handleSubmit = event => {
    // console.log('Type: ' + event.target.id);
    this.props.showCapGainsOrPerformance(event.target.id)
  }

  render() {
    return (
      <div className='row listoptions'>
        <div className='col-md-2 hidden-sm hidden-xs'></div>
        <div className='col-md-4 col-sm-12'>
          <div className='row'>
            {/* <label htmlFor="showWTFunds"> */}

            <div className='col-md-6 col-sm-9 col-xs-8 rightAlign'>
              <Switch onChange={this.handleChange} checked={this.state.checked} id='showWTFunds' onColor='#abebed' onHandleColor='#050139' offHandleColor='#fff' offColor='#8c959b' handleDiameter={20} uncheckedIcon={false} checkedIcon={false} boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)' activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)' height={15} width={30} />
            </div>
            <div className='col-md-6 col-sm-3 col-xs-4 leftAlign'>
              <span>Show similar WisdomTree funds</span>
            </div>
            {/* </label> */}
          </div>
        </div>
        <div className='col-md-6 col-sm-12 types'>
          <button onClick={this.handleSubmit} id='capgains' type='button' className={this.props.fundData.fundListType === 'capgains' ? 'isselected' : 'notselected'}>
            Capital Gains
          </button>
          <button onClick={this.handleSubmit} id='performance' type='button' className={this.props.fundData.fundListType === 'performance' ? 'isselected' : 'notselected'}>
            Performance
          </button>
          <button onClick={this.handleSubmit} id='funddetails' type='button' className={this.props.fundData.fundListType === 'funddetails' ? 'isselected' : 'notselected'}>
            Fund Details
          </button>
        </div>
      </div>
    )
  }
}
function mapStateToProps(state) {
  return {
    fundData: state.fundData
  }
}

export default connect(mapStateToProps, { showOrHideWTFunds, showCapGainsOrPerformance })(ListOptions)
